function toggleDescription() {
  const description = document.querySelector('.product__details-desktop .product-description');
  const button = document.getElementById('product-description-trigger-read');
  const arrow = document.getElementById('toggle-arrow');

  if (!description || !button) return;

  const isExpanded = description.classList.toggle('read-more');
  description.classList.toggle('read-less', !isExpanded);
  
  button.textContent = button.getAttribute(isExpanded ? 'data-read-less' : 'data-read-more');

  if(arrow) {
    arrow.classList.toggle('rotate');
  }
}

function toggleDescriptionDesktop() {
  console.log('toggleDescriptionDesktop called');
  const description = document.querySelector('.product__details-desktop .product-description');
  const button = document.getElementById('product-description-trigger-read-desktop');
  const arrow = document.getElementById('toggle-arrow-desktop');

  console.log('Desktop elements:', { description, button, arrow });
  if (!description || !button) {
    console.log('Missing desktop elements');
    return;
  }

  const isExpanded = description.classList.toggle('read-more');
  description.classList.toggle('read-less', !isExpanded);
  
  button.textContent = button.getAttribute(isExpanded ? 'data-read-less' : 'data-read-more');

  if(arrow) {
    arrow.classList.toggle('rotate');
  }
}

function toggleDescriptionMobile() {
  console.log('toggleDescriptionMobile called');
  const description = document.querySelector('.product__details-mobile .product-description');
  const button = document.getElementById('product-description-trigger-read-mobile');
  const arrow = document.getElementById('toggle-arrow-mobile');

  console.log('Mobile elements:', { description, button, arrow });
  if (!description || !button) {
    console.log('Missing mobile elements');
    return;
  }

  const isExpanded = description.classList.toggle('read-more');
  description.classList.toggle('read-less', !isExpanded);
  
  button.textContent = button.getAttribute(isExpanded ? 'data-read-less' : 'data-read-more');

  if(arrow) {
    arrow.classList.toggle('rotate');
  }
}

// Functie om te controleren of "lees meer" knop nodig is (tijdelijk uitgeschakeld)
// function checkReadMoreVisibility() {
//   // Functionaliteit tijdelijk weggehaald
// }

// Maak de functies direct globaal beschikbaar (buiten DOMContentLoaded)
window.toggleDescription = toggleDescription;
window.toggleDescriptionDesktop = toggleDescriptionDesktop;
window.toggleDescriptionMobile = toggleDescriptionMobile;
// window.checkReadMoreVisibility = checkReadMoreVisibility; // tijdelijk uitgeschakeld

// Prevent duplicate class declaration
if (typeof window.VariantMetafields !== 'undefined') {
  console.log('VariantMetafields already exists, skipping redeclaration');
} else {
  // Variant Metafields functionaliteit
  class VariantMetafields {
    constructor() {
      this.init();
    }

    init() {
      // Gebruik Dawn's ingebouwde pubsub systeem voor variant changes
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.updateVariantMetafields(event);
        });
      }

      // Fallback voor oudere themes of als pubsub niet beschikbaar is
      this.setupFallbackListeners();
    }

    setupFallbackListeners() {
      // Luister naar variant changes via custom events
      document.addEventListener('variant:change', (event) => {
        this.updateVariantMetafields(event.detail.variant);
      });

      // Luister naar input changes
      const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', (event) => {
          const variantId = event.target.value;
          this.updateVariantMetafields({ id: variantId });
        });
      });

      // Luister naar variant picker button clicks
      document.addEventListener('click', (event) => {
        if (event.target.closest('.product-form__input input[type="radio"]')) {
          setTimeout(() => {
            const selectedVariant = this.getCurrentVariant();
            if (selectedVariant) {
              this.updateVariantMetafields(selectedVariant);
            }
          }, 100);
        }
      });
    }

    getCurrentVariant() {
      const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"]');
      if (variantInput) {
        return { id: variantInput.value };
      }
      return null;
    }

    updateVariantMetafields(variant) {
      if (!variant || !variant.id || !window.variantMetafields) return;

      const variantData = window.variantMetafields[variant.id];
      if (!variantData) return;

      // Update alle variant metafields
      const variantRows = document.querySelectorAll('.specs-table tr[data-metafield-type="variant"]');
      
      // Voeg loading animatie toe
      variantRows.forEach(row => row.classList.add('updating'));
      
      setTimeout(() => {
        variantRows.forEach(row => {
          const valueCell = row.querySelector('.table-value');
          if (!valueCell) return;

          valueCell.classList.add('updating');
          
          const metafieldId = valueCell.getAttribute('data-metafieldid');
          const namespace = valueCell.getAttribute('data-namespace');
          const metafieldKey = `${namespace}.${metafieldId}`;

          if (variantData[metafieldKey]) {
            const data = variantData[metafieldKey];
            const value = data.value;
            const suffix = data.suffix || '';

            // Update de cell content
            if (value && value !== '') {
              valueCell.textContent = value + (suffix ? ' ' + suffix : '');
              row.style.display = '';
            } else {
              // Toon alleen als show_if_empty is ingeschakeld
              const showIfEmpty = row.hasAttribute('data-show-if-empty');
              if (showIfEmpty) {
                valueCell.textContent = '-';
                row.style.display = '';
              } else {
                row.style.display = 'none';
              }
            }
          }
          
          // Verwijder loading animatie
          setTimeout(() => {
            row.classList.remove('updating');
            valueCell.classList.remove('updating');
          }, 150);
        });
      }, 50);
    }

    // Cleanup function
    destroy() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
  }

  // Export voor gebruik in andere scripts
  window.VariantMetafields = VariantMetafields;
}

// Initialize alleen als er nog geen instance bestaat
document.addEventListener('DOMContentLoaded', () => {
  if (!window.variantMetafieldsInstance && window.VariantMetafields) {
    window.variantMetafieldsInstance = new window.VariantMetafields();
  }
  
  // Controleer of "lees meer" knoppen nodig zijn (tijdelijk uitgeschakeld)
  // setTimeout(() => {
  //   checkReadMoreVisibility();
  // }, 100);
});
